<template>
  <div class="MaterialModal">
    <el-dialog
        title=""
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :append-to-body="true"
        @open="handleOpen"
        width="30%"
    >
      <div class="contentBox">
        <div>
          <el-button
              v-if="materialType === 'image'"
              size="small"
              :class="curTab === 1 ? 'tabSelect' : 'tabUnSelect'"
              @click="selectTag(1)"
          >图片
          </el-button
          >
          <el-button
              v-if="materialType === 'audio'"
              size="small"
              :class="curTab === 2 ? 'tabSelect' : 'tabUnSelect'"
              @click="selectTag(2)"
          >音频
          </el-button
          >
          <el-button
              v-if="materialType === 'video'"
              size="small"
              :class="curTab === 3 ? 'tabSelect' : 'tabUnSelect'"
              @click="selectTag(3)"
          >视频
          </el-button
          >
          <el-button
              v-if="materialType === 'text'"
              size="small"
              :class="curTab === 4 ? 'tabSelect' : 'tabUnSelect'"
              @click="selectTag(4)"
          >知识
          </el-button
          >
          <el-button
              size="small"
              class="findButton"
              type="primary"
              @click="search"
          >查找
          </el-button
          >
          <el-input
              class="findInput"
              size="small"
              v-model="keyword"
              placeholder="名称"
          ></el-input>
        </div>
        <div class="materialContent">
          <div
              v-for="item in dataSource"
              :key="item.id"
              class="materialCard"
              :class="item.isSelect ? 'cardSelect' : ''"
          >
            <img
                v-if="curTab === 1"
                class="materialCardImage"
                :src="item.url"
                @click="onClickCard(item)"
            />

            <div class="materialCardText" @click="onClickCard(item)" v-if="curTab === 2">
              <div style="font-size: 1rem; line-height: 1rem;height: 50%">{{ item.name }}</div>
              <audio
                  class="materialCardAudio"
                  :src="item.url"
                  :loop="false"
                  controls
                  preload="auto"
                  v-text="item.name"
                  controlsList="nodownload noplaybackrate"
              ></audio>
            </div>

            <div v-if="curTab === 3" class="materialCardVideo" @click="onClickCard(item)">
              <y-j-video class="materialCardVideo"
                         :src="item.url"
                         :option="{controls:true,userActions:{click: false}}"
              />
            </div>

            <div v-if="curTab === 4" class="materialCardText" @click="onViewTextCard(item)">
              <div class="materialCardTextTitle">{{ item.title }}</div>
              <div class="materialCardTextContent">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <div class="pagenation">
          <AppPagination
              v-if="hasPagination && !loading"
              :pageSize="pagination.pageSize"
              :total="pagination.total"
              :currentPage="pagination.currentPage"
              :pageSizesArr="[15]"
              :layout="'prev, pager, next'"
              @pageChange="pageChange"
          />
        </div>
      </div>
      <div class="footer">
        <el-button
            v-if="curTab==4"
            style="width: 80px"
            type="primary"
            @click="handleConfirm"
        >关闭
        </el-button>
        <el-button
            v-else
            style="width: 80px"
            type="primary"
            @click="handleConfirm"
            :disabled="pickItem == null"
        >确定
        </el-button>
      </div>
    </el-dialog>
    <TextMaterialViewModal
        :materialInfo="viewMaterialInfo"
        :show="show"
    ></TextMaterialViewModal>
  </div>
</template>

<script>
import {mapMutations, mapActions} from "vuex";
import AppPagination from "@/components/ui/AppPagination/AppPagination";
import TextMaterialViewModal from "@/pages/MaterialCenter/components/TextMaterialViewModal.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "MaterialModal",
  components: {YJVideo, AppPagination, TextMaterialViewModal},
  props: {
    show: {
      default() {
        return {show: false}
      }
    },
    materialType: {
      type: String,
      default() {
        return "image";
      },
    },
    pickFrom: {
      type: String,
      default() {
        return "content";
      },
    },
  },
  data() {
    return {
      viewMaterialInfo: null,
      pickItem: null,
      keyword: "",
      curTab: 1,
      page: 1,
      size: 15,
      total: 1,
      hasPagination: true,
      loading: false,
      dataSource: [],
    };
  },
  created() {
  },
  computed: {
    pagination() {
      if (
          this.dataSource &&
          this.dataSource.length < 1 &&
          this.page !== 1 &&
          this.page * this.size > this.total
      ) {
        return {
          currentPage: this.page,
          pageSize: this.size,
          total: this.total + 1,
        };
      } else {
        return {
          currentPage: this.page || 1,
          pageSize: this.size || 10,
          total: this.total || 0,
        };
      }
    },
    visible: {
      get() {
        return this.show.show || this.$store.state.courseCenter.materialPickVisible;
      },
      set(value) {
        this.show.show = value;
        this.$store.commit("courseCenter/setData", {
          key: "materialPickVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapActions("courseCenter", [
      "searchMaterialResource",
      "saveMaterialResource",
      "deleteMaterialResource",
      "searchDisease",
      "saveDisease",
      "deleteDisease",
    ]),
    ...mapMutations("courseCenter", ["setData"]),
    handleOpen() {
      this.pickItem = null;
      if (this.materialType === "image") {
        this.curTab = 1;
      } else if (this.materialType === "audio") {
        this.curTab = 2;
      } else if (this.materialType === "video") {
        this.curTab = 3;
      } else if (this.materialType === "text") {
        this.curTab = 4;
      }
      this.getData();
    },
    onClickCard(item) {
      this.dataSource.map((i) => {
        i.isSelect = i.id === item.id;
      });
      this.pickItem = item;
    },
    onViewTextCard(item) {
      this.viewMaterialInfo = item;
      this.setData({key: "textMaterialVisible", value: true});
    },
    handleConfirm() {
      console.log(this.pickFrom);
      if (this.curTab !== 4) {
        this.$emit("onConfirmPickMaterial", this.pickItem);
      }
      this.visible = false;
      // this.setData({key: "materialPickVisible", value: false});
    },
    selectTag(type) {
      this.curTab = type;
      this.getData();
    },
    pageChange(item) {
      this.page = item.page;

      console.log(item);
      this.getData();
    },
    async getData() {
      this.pickItem = null;
      let res = {};
      if (this.curTab === 4) {
        res = await this.searchDisease({
          keyword: this.keyword,
          page: this.page,
          size: this.size,
          type: this.curTab,
        });
      } else {
        res = await this.searchMaterialResource({
          keyword: this.keyword,
          page: this.page,
          size: this.size,
          type: this.curTab,
        });
      }
      this.total = res.data.total;

      res.data.data.map((i) => {
        i.isSelect = false;
      });
      this.dataSource = res.data.data;
    },
    search() {
      this.page = 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
//.MultiContentModal {
::v-deep .el-dialog {
  min-width: 880px;
  min-height: 700px;
  position: relative;
  margin-top: 10vh !important;

  .el-dialog__header {
    box-shadow: none;
  }
}

.cardSelect {
  border: solid 2px blue;
}

.contentBox {
  min-width: 700px;
  padding: 10px;
  height: 570px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .contentRow {
  }

  .addButton {
    height: 36px;
    width: 500px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #10689c;
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

.MaterialCenter {
  .appBox {
  }
}

.tabSelect {
  background-color: #10689c;
  color: white;
}

.tabUnSelect {
}

.materialContent {
  margin-top: 20px;
  height: 430px;
  width: 685px;
  background-color: #ddd;
  float: left;

  .materialCard {
    float: left;
    width: 17.6%;
    height: 130px;
    overflow: hidden;
    margin-left: 2%;
    margin-top: 10px;

    .materialCardImage {
      background-color: white;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .materialCardAudio {
      background-color: white;
      width: 100%;
    }

    .materialCardVideo {
      background-color: white;
      width: 100%;
      height: 100%;
    }

    .materialCardText {
      background-color: white;
      width: 100%;
      height: 100%;
      padding: 10px;
      cursor: pointer;

      .materialCardTextTitle {
        font-size: 14px;
        line-height: 20px;
      }

      .materialCardTextContent {
        padding-top: 4px;
        font-size: 12px;
        padding-bottom: 10px;
        height: 90%;
        overflow: hidden;
        color: #999;
        line-height: 16px;
      }
    }
  }
}

.pagenation {
  text-align: center;
  clear: both;
  margin-top: -10px;
  display: flex;
  justify-content: center;
}

.findInput {
  width: 200px;
  float: right;
}

.findButton {
  float: right;
  margin-left: 0px;
}

.addButton {
  float: right;
}

//}
</style>
